import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const ServiceRequestsContainer = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;

	svg {
		path {
			fill: ${tokens.color_welbe};
		}
	}
`;
